import { ConsolidatedCoinData } from "@shared/types";
import { MARGIN_TYPE_TO_DISPLAY } from "@shared/common/constants";
import {
  checkTableRowSearch,
  getPercentSearchValues,
} from "utils/tableRowSearch";
import { getPositionFigures } from "features/portfolio/NewLook/positionFigures";

const SEARCH_FIELDS = [
  "clients",
  "exchanges",
  "quantity",
  "position_size",
  "margin",
  "unrealized_pnl",
  "entry_price",
  "liquidation_price",
  "price",
] as const satisfies readonly (keyof ConsolidatedCoinData)[];

export const checkPositionSearch = (
  position: ConsolidatedCoinData,
  search?: string,
  direction?: string
): boolean => {
  if (!search?.trim()) return true;
  const { roi } = getPositionFigures(position, false);
  return checkTableRowSearch(position.symbol, search, [
    SEARCH_FIELDS.map((field) => position[field]),
    direction,
    position.is_short ? "Short" : "Long",
    MARGIN_TYPE_TO_DISPLAY[position.margin_type],
    position.leverage ? `${position.leverage}x` : undefined,
    getPercentSearchValues(roi),
    position.graph_data?.change?.map(getPercentSearchValues),
  ]);
};
